import { render, staticRenderFns } from "./Pergunta.vue?vue&type=template&id=7c77b7f8&scoped=true"
import script from "./Pergunta.vue?vue&type=script&lang=ts"
export * from "./Pergunta.vue?vue&type=script&lang=ts"
import style0 from "./Pergunta.vue?vue&type=style&index=0&id=7c77b7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c77b7f8",
  null
  
)

export default component.exports